import { combineReducers } from 'redux'
import lesson from './lessonSlice'
import nclex from './nclexSlice'

export default combineReducers({
   lesson,
   nclex
})